<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="start" spaced>
          <FormButton
            text="Voltar para listagem de cupons"
            type="auxiliar"
            :disabled="!getFornecedorId"
            beforeIcon="fas fa-arrow-left"
            @click="voltarListagemCupons"
          />
        </FormButtonGroup>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="tableFilters"
        :noHideFilters="true"
        :search="false"
        :autoSearch="false"
        sortBy="created_at"
        :sortDesc="true"
        ref="datatable"
        :itemsPerPage="20"
      >
        <template v-slot:client_name="{ row }">
          <div class="historico-movimentacao__cliente">
            <div>{{ row.client_name || "—" }}</div>
            <div class="historico-movimentacao__cliente-meta">
              {{ row.email || "—" }}
            </div>
            <div class="historico-movimentacao__cliente-meta">
              {{ formatarCpfCnpj(row.cpf) }}
            </div>
          </div>
        </template>
        <template v-slot:tipo_movimento="{ row }">
          <span
            v-if="chipTipoMovimento(row.source)"
            class="historico-movimentacao__tipo-chip"
            :class="{
              'historico-movimentacao__tipo-chip--chart-down':
                row.source === 'RESGATE'
            }"
          >
            <v-chip
              small
              class="historico-movimentacao__chip"
              :color="chipTipoMovimento(row.source).color"
              text-color="white"
            >
              <v-icon
                left
                small
                class="historico-movimentacao__chip-icon ml-1 pr-2"
              >
                {{ chipTipoMovimento(row.source).icon }}
              </v-icon>
              <span class="pr-1">
                {{ chipTipoMovimento(row.source).text }}
              </span>
            </v-chip>
          </span>
          <span v-else>—</span>
        </template>
        <template v-slot:state="{ row }">
          <v-chip
            v-if="chipEstado(row.state || row.estado)"
            small
            class="historico-movimentacao__chip"
            :color="chipEstado(row.state || row.estado).color"
            text-color="white"
          >
            <v-icon
              left
              small
              class="historico-movimentacao__chip-icon ml-1 pr-2"
            >
              {{ chipEstado(row.state || row.estado).icon }}
            </v-icon>
            <span class="pr-1">
              {{ chipEstado(row.state || row.estado).text }}
            </span>
          </v-chip>
          <span v-else>—</span>
        </template>
        <template v-slot:points="{ row }">
          <span :class="classePontos(row)">
            {{ formatarPontosExibicao(row) }}
          </span>
        </template>
        <template v-slot:audit_operador="{ col }">
          {{ col && String(col).trim() !== "" ? col : "—" }}
        </template>
        <template v-slot:audit_motivo="{ col }">
          <span v-if="!textoMotivoValido(col)">—</span>
          <v-tooltip v-else-if="motivoPrecisaTooltip(col)" top>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="historico-movimentacao__motivo-truncado"
              >
                {{ formatarMotivoTruncado(col) }}
              </span>
            </template>
            <span>{{ String(col).trim() }}</span>
          </v-tooltip>
          <span v-else>{{ String(col).trim() }}</span>
        </template>
        <template v-slot:numpedido="{ col }">
          <v-chip
            v-if="col != null && String(col).trim() !== ''"
            small
            class="historico-movimentacao__chip"
            color="blue darken-1"
            text-color="white"
          >
            <v-icon
              left
              small
              class="historico-movimentacao__chip-icon ml-1 pr-2"
            >
              fas fa-shopping-cart
            </v-icon>
            <span class="pr-1">
              {{ String(col) }}
            </span>
          </v-chip>
          <span v-else>—</span>
        </template>
        <template v-slot:coupon_code="{ col }">
          <v-chip
            v-if="col != null && String(col).trim() !== ''"
            small
            class="historico-movimentacao__chip"
            color="green darken-2"
            text-color="white"
          >
            <v-icon
              left
              small
              class="historico-movimentacao__chip-icon ml-1 pr-2"
            >
              fas fa-ticket-alt
            </v-icon>
            <span class="pr-1">
              {{ String(col) }}
            </span>
          </v-chip>
          <span v-else>—</span>
        </template>
        <template v-slot:created_at="{ col }">
          {{ formatDateTime(col) }}
        </template>
      </DataTable>
    </Panel>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import { mapGetters } from "vuex";
import * as moment from "moment";
import MarketingModules from "@/components/MarketingModules";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { sanitizeDocument } from "@/utils/documentUtils";

function formatarDocumentoCnpjEstiloClienteForm(sanitized) {
  let i = 0;
  const take = maxLen => {
    const chunk = sanitized.slice(i, i + maxLen);
    i += chunk.length;
    return chunk;
  };
  const a = take(2);
  if (!a) {
    return sanitized;
  }
  let out = a;
  const b = take(3);
  if (b) {
    out += `.${b}`;
  }
  const c = take(3);
  if (c) {
    out += `.${c}`;
  }
  const d = take(4);
  if (d) {
    out += `/${d}`;
  }
  const e = take(2);
  if (e) {
    out += `-${e}`;
  }
  if (i < sanitized.length) {
    out += sanitized.slice(i);
  }
  return out;
}

export default {
  name: "ProgramaRecompensaHistoricoMovimentacao",
  components: {
    DataTable,
    Panel,
    FormButton,
    FormButtonGroup,
    MarketingModules
  },
  data: () => ({
    modulosForm: [
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP
    ],
    tableFilters: [
      {
        label: "Cliente (nome, e-mail, CPF/CNPJ, documento adicional)",
        query: "cliente",
        type: "text",
        default: "",
        cols: "4"
      },
      {
        label: "Tipo",
        query: "origem",
        type: "select",
        clearable: true,
        options: [
          { value: "PEDIDO", text: "Acúmulo" },
          { value: "RESGATE", text: "Resgate" },
          { value: "AJUSTE_MANUAL", text: "Ajuste manual" }
        ],
        default: ""
      },
      {
        label: "Estado",
        query: "estado",
        type: "select",
        multiple: "true",
        options: [
          { value: "PENDENTE", text: "Pendente" },
          { value: "CONFIRMADO", text: "Confirmado" },
          { value: "EXPIRADO", text: "Expirado" },
          { value: "CANCELADO", text: "Cancelado" }
        ],
        default: []
      },
      {
        label: "Data criação (início)",
        query: "data_inicio",
        type: "date",
        default: ""
      },
      {
        label: "Data criação (fim)",
        query: "data_fim",
        type: "date",
        default: ""
      }
    ],
    headers: [
      {
        text: "Cliente",
        value: "client_name",
        align: "left",
        sortable: false,
        clickable: false
      },
      {
        text: "Tipo",
        value: "tipo_movimento",
        align: "center",
        sortable: false,
        clickable: false
      },
      {
        text: "Estado",
        value: "state",
        align: "center",
        sortable: false,
        clickable: false
      },
      {
        text: "Pontos",
        value: "points",
        align: "center",
        sortable: true,
        clickable: false
      },
      {
        text: "Operador",
        value: "audit_operador",
        align: "left",
        sortable: false,
        clickable: false
      },
      {
        text: "Motivo",
        value: "audit_motivo",
        align: "left",
        sortable: false,
        clickable: false
      },
      {
        text: "Nº pedido",
        value: "numpedido",
        align: "center",
        sortable: false,
        clickable: false
      },
      {
        text: "Data",
        value: "created_at",
        align: "center",
        sortable: true,
        clickable: false
      },
      {
        text: "Cód. cupom",
        value: "coupon_code",
        align: "center",
        sortable: false,
        clickable: false
      }
    ]
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    endpoint() {
      return `/api/v4/programa-recompensa/movimentos-pontos/listar/${this.getFornecedorId}`;
    }
  },
  methods: {
    voltarListagemCupons() {
      this.$router.push({
        name: "ProgramaRecompensa"
      });
    },
    chipTipoMovimento(source) {
      if (source === "PEDIDO") {
        return {
          text: "Acúmulo",
          color: "blue darken-1",
          icon: "fas fa-chart-line"
        };
      }
      if (source === "RESGATE") {
        return {
          text: "Resgate",
          color: "green darken-2",
          icon: "fas fa-chart-line"
        };
      }
      if (source === "AJUSTE_MANUAL") {
        return {
          text: "Ajuste manual",
          color: "grey darken-1",
          icon: "fas fa-sliders-h"
        };
      }
      return null;
    },
    chipEstado(state) {
      const s = state != null ? String(state).trim() : "";
      if (!s) {
        return null;
      }
      const map = {
        PENDENTE: {
          text: "Pendente",
          color: "orange darken-2",
          icon: "fas fa-clock"
        },
        CONFIRMADO: {
          text: "Confirmado",
          color: "green",
          icon: "fas fa-check-circle"
        },
        EXPIRADO: {
          text: "Expirado",
          color: "grey darken-1",
          icon: "fas fa-hourglass-end"
        },
        CANCELADO: {
          text: "Cancelado",
          color: "red darken-2",
          icon: "fas fa-times-circle"
        }
      };
      return map[s] || { text: s, color: "grey", icon: "fas fa-info-circle" };
    },
    formatarCpfCnpj(value) {
      if (value == null || String(value).trim() === "") {
        return "—";
      }
      const sanitized = sanitizeDocument(value);
      if (!sanitized) {
        return "—";
      }
      if (sanitized.length === 11 && /^\d{11}$/.test(sanitized)) {
        return sanitized.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          "$1.$2.$3-$4"
        );
      }
      if (sanitized.length >= 14 || /[A-Z]/.test(sanitized)) {
        return formatarDocumentoCnpjEstiloClienteForm(sanitized);
      }
      if (sanitized.length > 11) {
        return formatarDocumentoCnpjEstiloClienteForm(sanitized);
      }
      return sanitized;
    },
    isAjusteManualRemover(row) {
      return (
        row &&
        row.source === "AJUSTE_MANUAL" &&
        String(row.audit_tipo_operacao || "").trim() === "REMOVER"
      );
    },
    textoMotivoValido(col) {
      return col != null && String(col).trim() !== "";
    },
    motivoPrecisaTooltip(col) {
      return String(col).trim().length > 50;
    },
    formatarMotivoTruncado(col) {
      const texto = String(col).trim();
      if (texto.length <= 50) {
        return texto;
      }
      return `${texto.slice(0, 50)}...`;
    },
    formatarPontosExibicao(row) {
      const raw = row.points;
      if (raw == null || raw === "") {
        return "—";
      }
      const n = parseFloat(String(raw).replace(",", "."));
      if (!Number.isFinite(n)) {
        return String(raw);
      }
      const frac = v =>
        Math.abs(v).toLocaleString("pt-BR", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        });
      if (row.source === "RESGATE" || this.isAjusteManualRemover(row)) {
        const v = n > 0 ? -n : n;
        if (v < 0) {
          return `-${frac(v)}`;
        }
        if (v > 0) {
          return `+${frac(v)}`;
        }
        return frac(0);
      }
      if (n > 0) {
        return `+${frac(n)}`;
      }
      if (n < 0) {
        return `-${frac(n)}`;
      }
      return frac(n);
    },
    classePontos(row) {
      if (row.source === "RESGATE" || this.isAjusteManualRemover(row)) {
        return "historico-movimentacao__pontos historico-movimentacao__pontos--resgate";
      }
      if (row.source === "PEDIDO" || row.source === "AJUSTE_MANUAL") {
        return "historico-movimentacao__pontos historico-movimentacao__pontos--acumulo";
      }
      return "historico-movimentacao__pontos";
    },
    formatDateTime(v) {
      if (v == null || v === "") {
        return "—";
      }
      return moment(v).isValid() ? moment(v).format("DD/MM/YYYY HH:mm") : v;
    }
  }
};
</script>

<style scoped>
.historico-movimentacao__cliente-meta {
  font-size: 12px;
  opacity: 0.85;
  line-height: 1.35;
}
.historico-movimentacao__pontos {
  font-weight: 600;
}
.historico-movimentacao__pontos--acumulo {
  color: #1565c0;
}
.historico-movimentacao__pontos--resgate {
  color: #059548;
}
.historico-movimentacao__tipo-chip {
  display: inline-block;
}
.historico-movimentacao__tipo-chip--chart-down
  .historico-movimentacao__chip-icon {
  transform: scaleY(-1);
}
.historico-movimentacao__chip {
  border-radius: 9999px !important;
  height: 26px !important;
  font-size: 12px;
  padding: 0 10px !important;
}
.historico-movimentacao__chip-icon {
  font-size: 12px !important;
  height: 14px !important;
  width: 14px !important;
  min-width: 14px !important;
  margin-right: 4px !important;
}
.historico-movimentacao__motivo-truncado {
  cursor: help;
  border-bottom: 1px dotted rgba(0, 0, 0, 0.35);
}
</style>
